import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Spinner } from 'telia-front-react';
import { INonPeriodicInvoicesSyncStore } from '../../stores/NonPeriodicInvoicesSyncStore';
import Invoices, { IInvoicesProps } from '../../pages/Invoices';

interface INonPeriodicInvoicesSyncProviderProps {
  componentProps?: IInvoicesProps;
  nonPeriodicInvoicesSyncStore?: INonPeriodicInvoicesSyncStore;
}

@inject('nonPeriodicInvoicesSyncStore')
@observer
export default class NonPeriodicInvoicesSyncProvider extends React.Component<INonPeriodicInvoicesSyncProviderProps> {
  public componentDidMount(): void {
    this.props.nonPeriodicInvoicesSyncStore.trySyncNonPeriodicInvoicesToBill();
  }

  public render(): React.ReactNode {
    const { syncResult } = this.props.nonPeriodicInvoicesSyncStore;

    if (syncResult.isInitialLoading) {
      return <Spinner />;
    }

    return <Invoices {...this.props.componentProps} />;
  }
}
